// Fronted/src/services/leadersService.js
import api from './api';

const leadersService = {
  getAllLeaders: async () => {
    try {
      const response = await api.get('/leaders');
      return response.data;
    } catch (error) {
      console.error('Error fetching leaders:', error);
      throw error;
    }
  },

  getLeaderByMinisry: async (ministryId) => {
    try {
      const response = await api.get(`/ministry/${ministryId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching leaders in ministry ${ministryId}:`, error);
      throw error;
    }
  },
  getLeaderByCell: async (cellId) => {
    try {
      const response = await api.get(`/cell/${cellId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching leaders in cell ${cellId}:`, error);
      throw error;
    }
  },

  createLeader: async (leaderData) => {
    try {
      const response = await api.post('/leaders', leaderData);
      return response.data;
    } catch (error) {
      console.error('Error creating leader:', error);
      throw error;
    }
  },

  updateLeader: async (id, leaderData) => {
    try {
      const response = await api.put(`/leaders/${id}`, leaderData);
      return response.data;
    } catch (error) {
      console.error(`Error updating leader ${id}:`, error);
      throw error;
    }
  },

  deleteLeader: async (id) => {
    try {
      const response = await api.delete(`/leaders/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting leader ${id}:`, error);
      throw error;
    }
  },

};

export default leadersService; 